import { Outlet } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'

export function AuthLayout() {
  return (
    <div className="relative flex min-h-[100dvh] w-full flex-col items-center justify-center p-4 sm:p-6 bg-background">
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/10 via-background to-background"
        aria-hidden="true"
      />

      <div className="relative z-10 w-full max-w-md">
        <div className="mb-8 flex items-center justify-center gap-3">
          <img src="/logo.svg" alt="PurpleToad Mail" className="h-10 w-10" />
          <span className="text-xl font-bold tracking-tight">PurpleToad Mail</span>
        </div>

        <Card className="w-full border-border/50 shadow-2xl">
          <CardContent className="p-6 sm:p-8">
            <Outlet />
          </CardContent>
        </Card>

        <p className="mt-6 text-center text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()} PurpleToad Mail. All rights reserved.
        </p>
      </div>
    </div>
  )
}
